var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrecipTomorrowio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    className: "weather-filter-parameter__icon--Huru",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5271,16.6152c-0.307,0-0.613,0.14-0.81,0.418 c-0.554,0.785-1.19,1.877-1.19,2.755c0,1.222,0.896,2.212,2,2.212s2-0.99,2-2.212c0-0.878-0.635-1.97-1.189-2.755 C13.1411,16.7552,12.8351,16.6152,12.5271,16.6152 M18.4998,10.1703c1.093,1.526,1.5,2.621,1.5,3.143c0,0.93-0.673,1.687-1.5,1.687 s-1.5-0.757-1.5-1.687C16.9998,12.7913,17.4078,11.6963,18.4998,10.1703 M18.4998,7.5293c-0.288,0-0.576,0.123-0.777,0.37 c-1.032,1.263-2.723,3.609-2.723,5.414c0,2.036,1.567,3.687,3.5,3.687c1.934,0,3.5-1.651,3.5-3.687c0-1.805-1.69-4.151-2.722-5.414 C19.0758,7.6523,18.7878,7.5293,18.4998,7.5293 M7.0271,5.0602c1.87,2.344,3,4.502,3,5.779c0,1.743-1.346,3.161-3,3.161 s-3-1.418-3-3.161C4.0271,9.5622,5.1581,7.4042,7.0271,5.0602 M7.0271,2.4922c-0.277,0-0.555,0.115-0.753,0.345 c-1.396,1.617-4.247,5.257-4.247,8.002c0,2.85,2.239,5.161,5,5.161c2.762,0,5-2.311,5-5.161c0-2.745-2.851-6.385-4.247-8.002 C7.5821,2.6072,7.3041,2.4922,7.0271,2.4922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecipTomorrowio);
export default __webpack_public_path__ + "static/media/precip-tomorrowio.241f47d0e49cfa94015dc3f753384ba6.svg";
export { ForwardRef as ReactComponent };